import { FETCH_ORDER_INFO_RESULT, FETCH_ORDER_INFO_FETCHING } from "../actions/index";

export default function(state = {
    isLoading: true,
    orderInfo: {

    }
}, action) {
  switch (action.type) {
      case FETCH_ORDER_INFO_FETCHING:
          return {...state, isLoading: true}
    case FETCH_ORDER_INFO_RESULT:
        const customer = action.payload.customer
        const paymentInfo = action.payload.paymentInfo
        const client = action.payload.client
      return { ...state, isLoading: false, orderInfo: {
          customer,
          paymentInfo,
          client
      } };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/order.js